import { useOutletContext } from 'react-router-dom';

import { Flex } from '@/lib/v2/components';

import IframeTransport from '@/src/compat/iframeTransport';
import { OutletContextActionsLayoutProps } from '@/src/modules/CampaignsModule/layouts/ActionsLayout';

const ActionContent = () => {
  const { showSpinnerByAction } = useOutletContext<OutletContextActionsLayoutProps>();

  return (
    <Flex column withGap gapSize="medium">
      <IframeTransport loading={showSpinnerByAction} />
    </Flex>
  );
};

export default ActionContent;
